
import { Action, createReducer, on } from '@ngrx/store';
import { EntityAcreditacionEmpresaAddFailure, EntityAcreditacionEmpresaAddRequest, EntityAcreditacionEmpresaAddSuccess, EntityAcreditacionEmpresaDeleteFailure, EntityAcreditacionEmpresaDeleteRequest, EntityAcreditacionEmpresaDeleteSuccess, EntityAcreditacionEmpresaLoadFailure, EntityAcreditacionEmpresaLoadRequest, EntityAcreditacionEmpresaLoadSuccess, EntityAcreditacionEmpresaUpdateFailure, EntityAcreditacionEmpresaUpdateRequest, EntityAcreditacionEmpresaUpdateSuccess } from './entity-acreditacion-empresa.actions';
import { EntityAcreditacionEmpresaState, entityAcreditacionEmpresaAdapter, initialState } from './entity-acreditacion-empresa.state';

const reducer = createReducer(
  initialState,
  on(EntityAcreditacionEmpresaLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityAcreditacionEmpresaAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityAcreditacionEmpresaUpdateRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityAcreditacionEmpresaDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityAcreditacionEmpresaLoadSuccess, (state, { items }) =>
    entityAcreditacionEmpresaAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })),
  on(EntityAcreditacionEmpresaLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),
  on(EntityAcreditacionEmpresaAddSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(EntityAcreditacionEmpresaAddFailure, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(EntityAcreditacionEmpresaDeleteFailure, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(EntityAcreditacionEmpresaUpdateFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),
  on(EntityAcreditacionEmpresaUpdateSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
);

export function EntityAcreditacionEmpresaReducer(
  state: EntityAcreditacionEmpresaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
